import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, Icon, Segment, Container } from "semantic-ui-react";

function Navbar() {
    return (
        <Segment className="navbar-container" attached size='maxi' style={{ margin: "0" }}>
            <Container>
                <Menu className="navbar-menu" secondary pointing>
                    <Menu.Item as={Link} to="/" style={{ padding: "0px", marginRight: "auto" }}>
                        <Menu.Header as="h1" className="navbar-header">
                            <Icon name="github" style={{ marginRight: "10px" }} />
                            GitHub Finder
                        </Menu.Header>
                    </Menu.Item>

                    <Menu.Item
                        as={NavLink}
                        to="/about"
                        style={{
                            padding: "10px 15px",
                            borderRadius: "10px",
                            transition: "all 0.3s ease"
                        }}
                    >
                        <Icon name="info circle" />
                        About
                    </Menu.Item>

                    <Menu.Item
                        as={Link}
                        to="https://github.com/devrudra9"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            padding: "10px 15px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            transition: "all 0.3s ease"
                        }}
                    >
                        <Icon name="github" />
                        devrudra9
                    </Menu.Item>
                </Menu>
            </Container>
        </Segment>
    )
}
export default Navbar;
